<template>
    <div>
        <v-alert :value="requestFailed" type="error" outline class="mt-4">
            <span>{{requestErrorMessage}}</span>
        </v-alert>
        <v-card-title primary-title>
            <div>
                <div class="headline">Export Comments</div>
            </div>
        </v-card-title>
        <v-card-text>
            <loading v-if="submitting" loadingMessage="Starting job..."></loading>
            <template v-else>
                <export-comments-form cancelButtonText="Cancel"
                                    :validateOnLoad="true"
                                    @update="formUpdated"
                                    @submitted="formSubmitted"
                                    @cancelled="formCancelled"
                                    submitButtonText="Start Job"></export-comments-form>
            </template>
        </v-card-text>
        <cancel-form-warning @abort="resetWaring" @confirm="cancel" :warnDialog="warnDialog"></cancel-form-warning>
    </div>
</template>

<script>
  import ExportCommentsForm from '@/forms/dataops/ExportCommentsForm'
  import CancelFormWarning from '@/views/app/elements/CancelFormWarning'
  import {CrudFormMixin} from '@/views/app/company/crud/crud-mixins'

  export default {
    name: 'dataops-exports-comments',
    mixins: [CrudFormMixin],
    components: {
      ExportCommentsForm,
      CancelFormWarning
    },
    data: () => ({}),
    created () {
    },
    computed: {
      apiPath () {
        return '/admin/dataops'
      }
    },
    methods: {
      handleSuccess(response) {
        const self = this
        self.$notifications.$emit('toast', {text: 'Successfully submitted job!', colour: 'success', buttonColour: ''})
        console.log(`[${self.formName}]: Successfully submitted: ${response}`)
        self.$router.push({name: 'dataops.jobs.read', params: {jobUID: response.jobUID}})
        self.submitting = false
      }
    }
  }
</script>

<style lang="scss">
</style>
